export const IMAGE_URL = `${process.env.REACT_APP_UPLOADED_FILE_URL}`;

export const ImageURLFormatter = (value) => {
  if(value){
    return `${IMAGE_URL}/${value}`;
  }
  else{
    return ""
  }
}